import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export function initBlockDepartments(parent) {
  if (!parent) return;

  const cards = parent.querySelectorAll('.department-card');
  cards.forEach((card, index) => {
    gsap.set(card, {
      opacity: 0,
      scale: 0.8,
      transformOrigin: 'center center',
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: card,
        start: 'top 75%',
        toggleActions: 'play none none none',
        once: true,
        // markers: true,
      },
      delay: ScrollTrigger.positionInViewport(card, 'top') <= 0.75 ? 0.85 : 0,
    });
    tl.to(card, {
      opacity: 1,
      scale: 1.01,
      duration: 0.5,
      ease: 'power1.out',
      delay: index * 0.1,
    }).to(card, {
      scale: 1,
      duration: 0.3,
      ease: 'power1.inOut',
    });
  });

  const hear = parent.querySelector('.block-departments__hear');
  const hearText = parent.querySelector('.block-departments__hear-text');
  const photos = parent.querySelectorAll('.block-departments__photo');

  const mm = gsap.matchMedia();

  mm.add(
    {
      isMobile: '(max-width: 767px)',
      isDesktop: '(min-width: 768px)',
    },
    (ctx) => {
      const { isMobile } = ctx.conditions;

      const fromX = isMobile ? 20 : -40;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: hear,
          start: 'top 75%',
          toggleActions: 'play none none none',
          once: true,
          // markers: true,
        },
      });

      tl.fromTo(
        hearText,
        { opacity: 0, y: 10 },
        { opacity: 1, y: 0, duration: 0.5, ease: 'power1.out' },
      );

      tl.fromTo(
        photos,
        { autoAlpha: 0, x: fromX },
        {
          autoAlpha: 1,
          x: 0,
          duration: 0.7,
          ease: 'power2.out',
          stagger: 0.12, // remove if you only have one photo
        },
        '-=0.2',
      );

      return () => {
        tl.kill();
        ScrollTrigger.refresh();
      };
    },
  );
}

export function initAllBlockDepartments() {
  const blocks = document.querySelectorAll('.js-block-departments');
  blocks.forEach((block) => initBlockDepartments(block));
}
